import {useEffect, useRef, useState} from "react";
import {t} from "@lingui/core/macro";

export default function TimeAgo({ datetime }){

    const interval = useRef(null);
    const [text, setText] = useState("");

    const endDate = new Date(datetime);

    const calculTimeAgo = () => {
        const currentTime = new Date();
        const timeRemaining = currentTime.getTime() - endDate.getTime();

        let seconds = Math.floor(timeRemaining / 1000);
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);
        let days = Math.floor(hours / 24);

        seconds %= 60;
        minutes %= 60;
        hours %= 24;

        if (days > 0) {
            return setText(t`il y a ${days} jour(s)`);
        }

        if (hours > 0) {
            return setText(t`il y a ${hours} heure(s)`);
        }

        if (minutes > 0) {
            return setText(t`il y a ${minutes} minute(s)`);
        }

        if (seconds > 0) {
            return setText(t`il y a ${seconds} seconde(s)`);
        }
    };

    useEffect(() => {
        calculTimeAgo();
        interval.current = setInterval(calculTimeAgo, 1000);

        return () => {
            clearInterval(interval.current);
        };
    }, []);

    return text;
};
